import { useTranslation } from 'react-i18next';
import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from '@/shared/ui/atoms/Button';
import { Input } from '@/shared/ui/atoms/Input';
import { FontIcon } from '@/shared/ui/atoms/FontIcon';
import '../AuthForm.styl';

/** Shown at /invitations without a token: lets the person paste the code from the email. */
export function TokenEntry() {
  const { t } = useTranslation(undefined, { keyPrefix: 'auth' });
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const submit = (e: FormEvent) => {
    e.preventDefault();
    const t = token.trim();
    if (t) navigate(`/invitations/${encodeURIComponent(t)}`);
  };
  return (
    <form className="f-auth" onSubmit={submit}>
      <h1 className="f-auth__title">{t('invitation.tokenTitle')}</h1>
      <p className="f-auth__lead">{t('invitation.tokenLead')}</p>
      <div className="f-auth__fields">
        <Input mono placeholder={t('invitation.tokenPlaceholder')} value={token} onChange={(e) => setToken(e.target.value)} aria-label={t('invitation.tokenPlaceholder')} leading={<FontIcon name="key2" />} />
      </div>
      <Button type="submit" block className="f-auth__submit" disabled={!token.trim()}>
        {t('invitation.tokenSubmit')}
      </Button>
      <div className="f-auth__foot">
        <Link className="f-auth__link" to="/login">
          {t('forgot.back')}
        </Link>
      </div>
    </form>
  );
}
